import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Button, Form, Fade, Container, Col, Row} from 'react-bootstrap';
import {Formik} from 'formik';
import DatePicker, {registerLocale} from 'react-datepicker';
import CommonMetaTag from './common-meta-tag';
import {reportTransactions} from '../actions/admin';
import 'react-datepicker/dist/react-datepicker.css';
import {useTranslation, Trans} from 'react-i18next';
import it from 'date-fns/locale/it';
registerLocale('it', it);

const addDays = (dateValue, days) => {
  const date = new Date(dateValue);
  date.setDate(date.getDate() + days);
  return date;
};

const PartnerReportTransactions = ({createReport}) => {
  const {t} = useTranslation();

  return (
    <Formik
      enableReinitialize
      initialValues={{start: null, end: null, email: '', surname: ''}}
      onSubmit={createReport}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        values
      }) => {
        return (
          <Fragment>
            <CommonMetaTag/>
            <Fade in appear className="partner-report-skywork-content">
              <Container fluid>
                <Row className="justify-content-center">
                  <Col xs={12} lg={9} xl={8}>
                    <section className="partner-report-skywork-card">
                    <div className="partner-report-skywork-card-head"><span className="partner-report-skywork-card-icon"><i className="fa fa-credit-card"/></span><div><h2>{t('TRANSACTION_REGISTER')}</h2><p>{t('SELECT_PERIOD')}</p></div></div>
                    <Form onSubmit={handleSubmit}>
                      <Form.Row>
                        <Col>
                          <Form.Group>
                            <Form.Label>{t('START_DATE')}</Form.Label><br/>
                            <DatePicker
                              locale="it"
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              selected={(values.start && new Date(values.start)) || null}
                              onChange={val => setFieldValue('start', val ? new Date(val).toISOString() : null)}/>
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group>
                            <Form.Label>{t('END_DATE')}</Form.Label><br/>
                            <DatePicker
                              locale="it"
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              selected={(values.end && addDays(values.end, -2)) || null}
                              onChange={val => setFieldValue('end', val ? addDays(val, 2).toISOString() : null)}/>
                          </Form.Group>
                        </Col>
                      </Form.Row>
                      <div className="partner-report-skywork-note"><i className="fa fa-info-circle"/><span>{<Trans i18nKey='TRANSACTION_REPORT_EMAIL_SURNAME_INFO'/>}</span></div>
                      <Form.Group>
                        <Form.Label>{t('PLAYER_EMAIL_OR_YOUR_OWN')}</Form.Label>
                        <Form.Control name="email" type="text" maxLength={255} placeholder={t('PLAYER_EMAIL_OR_YOUR_OWN')} value={values.email || ''} onChange={handleChange}/>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>{t('PLAYER_SURNAME_OR_YOUR_BUSINESS_NAME')}</Form.Label>
                        <Form.Control name="surname" type="text" maxLength={255} placeholder={t('PLAYER_SURNAME_OR_YOUR_BUSINESS_NAME')} value={values.surname || ''} onChange={handleChange}/>
                      </Form.Group>
                      <Button type="submit" className="partner-report-skywork-primary"><i className="fa fa-download"/> {t('EXTRACT_XLS')}</Button>
                    </Form>
                    </section>
                  </Col>
                </Row>
              </Container>
            </Fade>
          </Fragment>
        );
      }}
    </Formik>
  );
};

PartnerReportTransactions.propTypes = {
  createReport: PropTypes.func.isRequired
};

const mapStateToProps = ({partner: {ownedFields}}) => ({
    ownedFields
});
  
const mapDispatchToProps = dispatch => ({
    createReport: values => {
      dispatch(reportTransactions(values));
    }
});
  
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(PartnerReportTransactions));
